import { render, staticRenderFns } from "./MorrisChart.vue?vue&type=template&id=02a3ed30"
import script from "./MorrisChart.vue?vue&type=script&lang=js"
export * from "./MorrisChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports